/**
 * Ashore API
 * All Endpoints to control your ashore account
 *
 * The version of the OpenAPI document: V1
 * Contact: info@ashoreapp.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import NotificationFrequencyOption from './NotificationFrequencyOption';

/**
 * The UpdateUserDefaultSettingsRequest model module.
 * @module model/UpdateUserDefaultSettingsRequest
 * @version V1
 */
class UpdateUserDefaultSettingsRequest {
    /**
     * Constructs a new <code>UpdateUserDefaultSettingsRequest</code>.
     * @alias module:model/UpdateUserDefaultSettingsRequest
     */
    constructor() { 
        
        UpdateUserDefaultSettingsRequest.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>UpdateUserDefaultSettingsRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/UpdateUserDefaultSettingsRequest} obj Optional instance to populate.
     * @return {module:model/UpdateUserDefaultSettingsRequest} The populated <code>UpdateUserDefaultSettingsRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new UpdateUserDefaultSettingsRequest();

            if (data.hasOwnProperty('downloadFiles')) {
                obj['downloadFiles'] = ApiClient.convertToType(data['downloadFiles'], 'Boolean');
            }
            if (data.hasOwnProperty('approveIndividualFiles')) {
                obj['approveIndividualFiles'] = ApiClient.convertToType(data['approveIndividualFiles'], 'Boolean');
            }
            if (data.hasOwnProperty('viewAllComments')) {
                obj['viewAllComments'] = ApiClient.convertToType(data['viewAllComments'], 'Boolean');
            }
            if (data.hasOwnProperty('approveWithChanges')) {
                obj['approveWithChanges'] = ApiClient.convertToType(data['approveWithChanges'], 'Boolean');
            }
            if (data.hasOwnProperty('notifyFilesSent')) {
                obj['notifyFilesSent'] = ApiClient.convertToType(data['notifyFilesSent'], 'Boolean');
            }
            if (data.hasOwnProperty('limitVersionVisibility')) {
                obj['limitVersionVisibility'] = ApiClient.convertToType(data['limitVersionVisibility'], 'Boolean');
            }
            if (data.hasOwnProperty('blockCommentingAfterProofDecision')) {
                obj['blockCommentingAfterProofDecision'] = ApiClient.convertToType(data['blockCommentingAfterProofDecision'], 'Boolean');
            }
            if (data.hasOwnProperty('watermarkEnabled')) {
                obj['watermarkEnabled'] = ApiClient.convertToType(data['watermarkEnabled'], 'Boolean');
            }
            if (data.hasOwnProperty('notifyFilesApproved')) {
                obj['notifyFilesApproved'] = ApiClient.convertToType(data['notifyFilesApproved'], 'Boolean');
            }
            if (data.hasOwnProperty('notifyNewComments')) {
                obj['notifyNewComments'] = ApiClient.convertToType(data['notifyNewComments'], 'Boolean');
            }
            if (data.hasOwnProperty('notifyJobAssigned')) {
                obj['notifyJobAssigned'] = ApiClient.convertToType(data['notifyJobAssigned'], 'Boolean');
            }
            if (data.hasOwnProperty('notifyNewContactComments')) {
                obj['notifyNewContactComments'] = NotificationFrequencyOption.constructFromObject(data['notifyNewContactComments']);
            }
            if (data.hasOwnProperty('notifyNewReviewerComments')) {
                obj['notifyNewReviewerComments'] = NotificationFrequencyOption.constructFromObject(data['notifyNewReviewerComments']);
            }
            if (data.hasOwnProperty('reminderDays')) {
                obj['reminderDays'] = ApiClient.convertToType(data['reminderDays'], 'String');
            }
            if (data.hasOwnProperty('reminderTimeOfDay')) {
                obj['reminderTimeOfDay'] = ApiClient.convertToType(data['reminderTimeOfDay'], 'String');
            }
            if (data.hasOwnProperty('reminderTimeZone')) {
                obj['reminderTimeZone'] = ApiClient.convertToType(data['reminderTimeZone'], 'String');
            }
            if (data.hasOwnProperty('dailyDigestTimeOfDay')) {
                obj['dailyDigestTimeOfDay'] = ApiClient.convertToType(data['dailyDigestTimeOfDay'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>UpdateUserDefaultSettingsRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>UpdateUserDefaultSettingsRequest</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['reminderDays'] && !(typeof data['reminderDays'] === 'string' || data['reminderDays'] instanceof String)) {
            throw new Error("Expected the field `reminderDays` to be a primitive type in the JSON string but got " + data['reminderDays']);
        }
        // ensure the json data is a string
        if (data['reminderTimeOfDay'] && !(typeof data['reminderTimeOfDay'] === 'string' || data['reminderTimeOfDay'] instanceof String)) {
            throw new Error("Expected the field `reminderTimeOfDay` to be a primitive type in the JSON string but got " + data['reminderTimeOfDay']);
        }
        // ensure the json data is a string
        if (data['reminderTimeZone'] && !(typeof data['reminderTimeZone'] === 'string' || data['reminderTimeZone'] instanceof String)) {
            throw new Error("Expected the field `reminderTimeZone` to be a primitive type in the JSON string but got " + data['reminderTimeZone']);
        }

        return true;
    }


}



/**
 * @member {Boolean} downloadFiles
 */
UpdateUserDefaultSettingsRequest.prototype['downloadFiles'] = undefined;

/**
 * @member {Boolean} approveIndividualFiles
 */
UpdateUserDefaultSettingsRequest.prototype['approveIndividualFiles'] = undefined;

/**
 * @member {Boolean} viewAllComments
 */
UpdateUserDefaultSettingsRequest.prototype['viewAllComments'] = undefined;

/**
 * @member {Boolean} approveWithChanges
 */
UpdateUserDefaultSettingsRequest.prototype['approveWithChanges'] = undefined;

/**
 * @member {Boolean} notifyFilesSent
 */
UpdateUserDefaultSettingsRequest.prototype['notifyFilesSent'] = undefined;

/**
 * @member {Boolean} limitVersionVisibility
 */
UpdateUserDefaultSettingsRequest.prototype['limitVersionVisibility'] = undefined;

/**
 * @member {Boolean} blockCommentingAfterProofDecision
 */
UpdateUserDefaultSettingsRequest.prototype['blockCommentingAfterProofDecision'] = undefined;

/**
 * @member {Boolean} watermarkEnabled
 */
UpdateUserDefaultSettingsRequest.prototype['watermarkEnabled'] = undefined;

/**
 * @member {Boolean} notifyFilesApproved
 */
UpdateUserDefaultSettingsRequest.prototype['notifyFilesApproved'] = undefined;

/**
 * @member {Boolean} notifyNewComments
 */
UpdateUserDefaultSettingsRequest.prototype['notifyNewComments'] = undefined;

/**
 * @member {Boolean} notifyJobAssigned
 */
UpdateUserDefaultSettingsRequest.prototype['notifyJobAssigned'] = undefined;

/**
 * @member {module:model/NotificationFrequencyOption} notifyNewContactComments
 */
UpdateUserDefaultSettingsRequest.prototype['notifyNewContactComments'] = undefined;

/**
 * @member {module:model/NotificationFrequencyOption} notifyNewReviewerComments
 */
UpdateUserDefaultSettingsRequest.prototype['notifyNewReviewerComments'] = undefined;

/**
 * @member {String} reminderDays
 */
UpdateUserDefaultSettingsRequest.prototype['reminderDays'] = undefined;

/**
 * @member {String} reminderTimeOfDay
 */
UpdateUserDefaultSettingsRequest.prototype['reminderTimeOfDay'] = undefined;

/**
 * @member {String} reminderTimeZone
 */
UpdateUserDefaultSettingsRequest.prototype['reminderTimeZone'] = undefined;

/**
 * @member {String} dailyDigestTimeOfDay
 */
UpdateUserDefaultSettingsRequest.prototype['dailyDigestTimeOfDay'] = undefined;






export default UpdateUserDefaultSettingsRequest;

